/* eslint-disable react/jsx-no-literals */
import AppLogo from '@/assets/icons/app-logo.svg?react';
import packageJson from '../package.json';

export const ErrorRender = ({ error }: { error: Error }) => {
  const handleCopyToClipboard = () => {
    const copyText = document.getElementById('frontend-error-log');
    if (!copyText) {
      return;
    }
    navigator.clipboard.writeText(copyText.textContent || '');
  };
  return (
    <div className="w-[100vw] h-[100vh] flex flex-col justify-center items-center bg-light-gray">
      <div className="flex flex-col items-center justify-center">
        <div className="flex flex-row items-center mb-8">
          <AppLogo className="mr-1" />
          <h1>Process Lifecycle Navigator</h1>
        </div>
        <div className="flex flex-col gap-y-2 px-3 py-3 bg-white min-w-[700px] shadow rounded">
          <p className="typo-primary-400 text-center">
            The application experienced an error and crashed. We apologize for any inconvenience this may have caused.
          </p>
          <p className="typo-primary-400 text-center">
            Here is an error log that you can share with us to ensure that this does not happen again:
          </p>
          <p
            onClick={handleCopyToClipboard}
            data-test-id="frontend-error-copy-to-clipboard-button"
            className="typo-primary-400 underline text-right cursor-pointer"
          >
            Copy to clipboard
          </p>
          <pre id="frontend-error-log" data-testid="frontend-error-log" className="text-sm border border-other-stroke">
            URL: {window.location.href}
            {'\n'}
            App version: {packageJson.version}
            {'\n'}
            Error message: {error.message}
            {'\n'}
            {error.stack}
          </pre>
        </div>
      </div>
    </div>
  );
};
